import { SequenceManagerAction } from '../actions/SequenceManagerAction';

const PersonalDetailsAction = {
    PERSONAL_DETAILS_SUCCESS : 'PERSONAL_DETAILS_SUCCESS',
}


const getPersonalDetails = (fName: any, mName: any, lName: any, phone: any,  email: any, birthDate: any, birthdayType: any) => {
    return function (dispatch: any) {
        dispatch({ type: PersonalDetailsAction.PERSONAL_DETAILS_SUCCESS, payload: {fName: fName, mName: mName, lName: lName, phone: phone, email: email, birthDate: birthDate, birthdayType: birthdayType} });
        dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['PersonalDetails'] });
    }
}


export { PersonalDetailsAction, getPersonalDetails };